import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { MatCheckbox } from '@angular/material';
import { BooleanFilter, FilterComponentBase } from '../filters/filters';
var CheckboxFilterComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CheckboxFilterComponent, _super);
    function CheckboxFilterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.change = new EventEmitter();
        _this.onChangeCallback = function (_) { };
        return _this;
    }
    CheckboxFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkbox.change.subscribe(function (e) {
            _this.onChangeCallback(e.checked);
            _this.change.emit(e.checked);
        });
    };
    CheckboxFilterComponent.prototype.writeValue = function (value) {
        if (value !== undefined) {
            this.filter.enabled = value;
        }
    };
    CheckboxFilterComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    CheckboxFilterComponent.prototype.registerOnTouched = function (fn) {
        this.checkbox.registerOnTouched(fn);
    };
    return CheckboxFilterComponent;
}(FilterComponentBase));
export { CheckboxFilterComponent };
